export default __webpack_public_path__ + "static/media/challenges.de798420.png";